import { render, staticRenderFns } from "./StepContact.vue?vue&type=template&id=6ddf6e8e&"
import script from "./StepContact.vue?vue&type=script&lang=js&"
export * from "./StepContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports